
import ko from 'rgs-knockout';

import Model from './js/model';
import template from './templates/control.html';


ko.components.register('kv-summary-valid-value', {
	viewModel: Model,
	template: template(),
});

